import $ from 'jquery';
import 'magnific-popup';
import slick from 'slick-carousel';

const landingpage = () => {
    
    const page = $('body.page-template-page-landing');

    if (page) {
    
	    $('#histoire .more.plus span', page).click(function()
	    {
		    $('#histoire').addClass('showmore');
		});
		
		$('#histoire .more.moins span', page).click(function()
	    {
		    $('#histoire').removeClass('showmore');
		});
		
		$('#slider ul', page).slick({
            responsive: [
                {
                    breakpoint: 999999,
                    settings: {
                        adaptiveHeight: true,
                        arrows: false,
                        dots: true,
                        easing: 'easeOutExpo',
                        infinite: true,
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        speed: 400,
                        variableWidth: false,
                        autoplay: true,
                        autoplaySpeed: 4000
                    },
                },
            ],
        });
        
        $('body.page-template-page-landing').append('<div id="overall_landing"></div>');
        
        
        $('.handheld-navigation a').click(function()
        {
	     	$('header .bars').trigger('click');   
	    });
	    
	    
	    $('body.page-template-page-landing #landing .product .recto .more span').click(function()
	    {
			$(this).parents('.slick-slide:first').addClass('showverso');
			$(this).parents('.gamme:first').addClass('showverso');
			$('body').addClass('showverso');
		});
		
		$('body.page-template-page-landing #landing .product .verso .more span').click(function()
	    {
			$('body.page-template-page-landing #landing .slick-slide').removeClass('showverso');
			$('body.page-template-page-landing #landing .gamme').removeClass('showverso');
			$('body').removeClass('showverso');
		});
		
		$('#overall_landing').click(function()
		{
			$('body.page-template-page-landing #landing .slick-slide').removeClass('showverso');
			$('body.page-template-page-landing #landing .gamme').removeClass('showverso');
			$('body').removeClass('showverso');
		});
	}

	/**
	 * Contact form
	 */
	function checkStatusField()
	{
		if ( $('#input_5_1').val() === 'Professional' ) {
			$('#input_5_2 option').each(function() {
				if ( $.inArray($(this).attr('value'), ['Other request', 'Request for partnership']) === -1 ) {
					$(this).hide();
				}
				else {
					$(this).show();
				}
			});
			$('#input_5_2').val('Request for partnership').trigger('change');
			checkSubjectField();
		}
		else {
			$('#input_5_2 option').each(function() {
				if ( $.inArray($(this).attr('value'), ['Request for partnership']) === -1 ) {
					$(this).show();
				}
				else {
					$(this).hide();
				}
			});
			let val = $('#input_5_2').val();
			if ( val === 'Request for partnership' ) {
				val = 'Where to find a product?';
			}
			$('#input_5_2').val(val).trigger('change');
			checkSubjectField();
		}
	}
	checkStatusField();

	$('body').on('change', '#input_5_1', function() {
		checkStatusField();
	});

	function checkSubjectField()
	{
		if ( $('#input_5_1').val() === 'Professional' && $.inArray($('#input_5_2').val(), ['Other request', 'Request for partnership']) !== -1 ) {
			$('#field_5_3').removeClass('hide-field');
		}
		else {
			$('#field_5_3').addClass('hide-field');
		}
	}
	checkSubjectField();

	$('body').on('change', '#input_5_2', function() {
		checkSubjectField();
	});

	function initCguPopin()
	{
		let locale = $('#landing').attr('data-locale');

		$('.display-terms').attr('href', '#terms_' + locale);
		$('.display-privacy').attr('href', '#privacy_' + locale);

		$('.display-terms').magnificPopup({
			type: 'inline'
		});

		$('.display-privacy').magnificPopup({
			type: 'inline'
		});
	}
	initCguPopin();

	if ( typeof gform !== 'undefined' ) {
		gform.addAction('gform_post_recaptcha_render', function (elem) {
			if ( $(elem).attr('id') === 'input_5_10' ) {
				console.log('pouet');
				checkStatusField();
				checkSubjectField();
				initCguPopin();
			}
		});
	}
}

export default landingpage;
